export enum CategoriesStoreKeys {
  InUse = 'inUse',
  All = 'all',
}

export enum ProductsStoreKeys {
  Favorite = 'favorite',
}

export enum ProductCodesStoreKeys {
  All = 'all',
}
